<template>
  <VoucherLedgerList
    flag="CR"
    :title="$t('credit_voucher')"
    create-route="CreditVoucherCreate"
    :create-label="$t('add_credit_voucher')"
    table-id="CreditVoucherTable"
    head-icon="ti-cash"
  />
</template>

<script>
import VoucherLedgerList from '@/components/accounts/VoucherLedgerList.vue';

export default {
  components: { VoucherLedgerList },
};
</script>
